export default __webpack_public_path__ + "static/media/0x032f85b8fbf8540a92b986d953e4c3a61c76d39e.0f5cdec0.webp";